export interface IUserProfileModel {
  email: string;
  firstName: string;
  lastName: string;
  preferredLanguage: string;
  preferredUnitSystem: string;
  profilePhotoUrl: string;
  userId: string;
}

export interface orgAdminData {
  email: string;
  name: string;
}

export enum UserType {
  Admin = 'Admin',
  Coach = 'Coach',
}
